@if (isVisible() && instructions(); as info) {
  <aside class="pwa-install" aria-labelledby="pwa-install-title">
    <div class="pwa-install__head">
      <img class="pwa-install__icon" ngSrc="assets/logo-big.svg" width="40" height="40" alt="" />
      <div class="pwa-install__intro">
        <h2 class="pwa-install__title" id="pwa-install-title">{{ info.title }}</h2>
        <p class="pwa-install__lead">{{ info.lead }}</p>
      </div>
      <button type="button" class="pwa-install__close" aria-label="Close" (click)="dismiss()">
        <ion-icon name="close" aria-hidden="true"></ion-icon>
      </button>
    </div>

    @if (info.steps.length > 0) {
      <ol class="pwa-install__steps">
        @for (step of info.steps; track $index) {
          <li class="pwa-install__step">
            {{ step.text }}
            @if (step.icon) {
              <ion-icon
                class="pwa-install__inline-icon"
                [name]="step.icon"
                role="img"
                [attr.aria-label]="step.iconLabel"
              ></ion-icon>
            }
            {{ step.textAfter }}
          </li>
        }
      </ol>
    }

    @if (info.footnote) {
      <p class="pwa-install__footnote">{{ info.footnote }}</p>
    }

    <div class="pwa-install__actions">
      @if (showNativeInstall()) {
        <button type="button" class="btn btn-primary pwa-install__install" (click)="install()">
          <ion-icon name="download-outline" aria-hidden="true"></ion-icon>
          Install app
        </button>
      }
      <button type="button" class="btn btn-outline pwa-install__dismiss" (click)="dismiss()">
        {{ dismissLabel() }}
      </button>
    </div>
  </aside>
}
